export default function AboutUs() {
  return (
    <section
      id="nosotros"
      className="py-24 relative"
      style={{
        backgroundImage: "url('https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/1a6478595ecc4e525957941b20cfbdfd.webp')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay oscuro */}
      <div className="absolute inset-0" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12">
        {/* Etiqueta superior */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-5 py-2 border-2 border-[#C9A86A] rounded-full mb-8">
            <span className="text-[#C9A86A] text-xs font-semibold tracking-wider uppercase">
              Acerca de CMC
            </span>
          </div>

          {/* Título sin íconos */}
          <h2 className="text-5xl lg:text-7xl font-heading font-bold text-white leading-tight">
            Más de 15 años de experiencia<br />
            en construcción<br />
            y mantenimiento
          </h2>
        </div>

        {/* Contenido descriptivo */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">Nuestra Historia</h3>
            <p className="text-white/70 leading-relaxed mb-6">
              CMC nace de la pasión por crear espacios funcionales y duraderos. Con más de 15 años en el sector, somos una empresa con base en Saltillo, Coahuila, con cobertura regional que incluye Monterrey y su zona metropolitana.
            </p>
            <p className="text-white/70 leading-relaxed">
              Especializados en construcción, mantenimiento e instalaciones, ofrecemos soluciones integrales para proyectos residenciales, comerciales e industriales en toda la región noreste de México.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-white mb-4">Nuestro Compromiso</h3>
            <p className="text-white/70 leading-relaxed mb-6">
              Trabajamos con los más altos estándares de calidad, con materiales de primera y un equipo de profesionales altamente capacitados. Cada proyecto lo tratamos con la dedicación que merece.
            </p>
            <p className="text-white/70 leading-relaxed">
              Nuestro objetivo es superar las expectativas de nuestros clientes, entregando proyectos en tiempo y forma, con acabados impecables y garantía de satisfacción.
            </p>
          </div>
        </div>

        {/* Estadísticas */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="text-5xl font-bold text-[#C9A86A] mb-2">15+</div>
            <div className="text-white/70 font-medium">Años de Experiencia</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#C9A86A] mb-2">
              <i className="ri-building-line"></i>
            </div>
            <div className="text-white/70 font-medium">Proyectos ejecutados en diversos sectores</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-[#C9A86A] mb-2">100%</div>
            <div className="text-white/70 font-medium">Garantía de Calidad</div>
          </div>
        </div>
      </div>
    </section>
  );
}